import { PageContext } from 'context/PageContext';
import { useContext, useMemo } from 'react';
import { apiInstance, getProxyUrl } from '../services/Api';

export interface SearchParams {
	params: [
		{
			param: string;
			search_config_lov: Lov[];
		},
	];
}
export interface Template {
	templates: TemplateElement[];
}

export interface TemplateElement {
	fieldID: string;
	mandatory: boolean;
	label: string;
	lov: Lov[];
	value: string;
}

type SearchType = {
	uuid: string;
	params: SearchParam[];
};

type SearchParam = {
	param_name: string;
	param_value: string;
};

export interface Lov {
	label: string;
	value: string;
}

type search_config_lov = Lov;

export interface SpdSearchInputField {
	param: string;
	value: string | number | boolean | object;
}

interface UseSpdSearchProps {
	spdSearchType: SpdSearchType;
}

export const useSpdSearch = ({ spdSearchType }: UseSpdSearchProps) => {
	const pageContext = useContext(PageContext);

	// Determine the URL: from spdSearchType or from context fallback
	const url = useMemo(() => {
		const metaAreaContent = pageContext?.metaArea?.items?.[0];

		return (
			spdSearchType.searchConfiguration.url ||
			getProxyUrl(metaAreaContent, metaAreaContent?.content?.quoteSearchConfigurationApiEndpoint?.url) ||
			''
		);
	}, [spdSearchType, pageContext]);

	const doMakeSearch = async (): Promise<Lov[]> => {
		if (!url) {
			console.error('No URL defined for SPD search.');
			return [];
		}
		const method = spdSearchType.searchConfiguration.httpMethod?.toLowerCase?.() || 'get';

		try {
			const res: Template = await apiInstance()[method](url);
			return res.templates[0]?.lov ?? [];
		} catch (error) {
			// TODO: Add modal when error
			console.error('SPD search failed:', error);
			return [];
		}
	};

	const doSearch = async (searchType?: SearchType): Promise<Lov[]> => {
		if (!url) {
			console.error('No URL defined for SPD search.');
			return [];
		}
		const method = spdSearchType.searchConfiguration.httpMethod?.toLowerCase?.() || 'get';

		try {
			const res: SearchParams = await apiInstance()[method](url, searchType);
			return res.params[0]?.search_config_lov ?? [];
		} catch (error) {
			// TODO: Add modal when error
			console.error('SPD search failed:', error);
			return [];
		}
	};

	return { doSearch, doMakeSearch };
};
